import React, { useState, useEffect } from "react";
import Sidebar from "../Sidebar";
import "../../assets/css/admin/uploadVideo.css";
import Footer from "../../components/common/Footer";

import { VIDEO_UPLOAD_URL, UPLOAD_PRESET } from "../../services/cloudinary";
import AdminNavbar from "../AdminNavbar";
import { db } from "../../firebase/firebase";
import {
    collection,
    addDoc,
    getDocs,
    serverTimestamp
} from "firebase/firestore";

function UploadVideo() {

    const [title, setTitle] = useState("");
    const [description, setDescription] = useState("");
    const [category, setCategory] = useState("");
    const [categories, setCategories] = useState([]);
    const [video, setVideo] = useState(null);

    const [loading, setLoading] = useState(false);
    const [errors, setErrors] = useState({});
    const [popup, setPopup] = useState({
    show: false,
    type: "",
    message: ""
});

    useEffect(() => {

        loadCategories();

    }, []);

    const loadCategories = async () => {

        try {

            const snapshot = await getDocs(
                collection(db, "gallery_categories")
            );

            const categoryList = [];

            snapshot.forEach((doc) => {

                categoryList.push({
                    id: doc.id,
                    ...doc.data()
                });

            });

            setCategories(categoryList);

        } catch (error) {

    console.error("Video Upload Error:", error);

    let errorMessage =
        "We couldn't upload your video right now. Please check your internet connection and try again.";

    if (error.message === "Video Upload Failed") {

        errorMessage =
            "The video could not be uploaded to the cloud storage. Please verify the file format, file size, and try again.";

    } else if (error.code === "permission-denied") {

        errorMessage =
            "You don't have permission to upload videos. Please contact the administrator.";

    } else if (error.code === "unavailable") {

        errorMessage =
            "The server is temporarily unavailable. Please wait a few moments and try again.";

    } else if (error.code === "network-request-failed") {

        errorMessage =
            "Network connection lost while uploading the video. Please check your internet connection and try again.";

    }

    setPopup({
        show: true,
        type: "error",
        message: errorMessage
    });

    setTimeout(() => {

        setPopup({
            show: false,
            type: "",
            message: ""
        });

    }, 4000);

} finally {

    setLoading(false);

}

    };

    const handleSubmit = async (e) => {

        e.preventDefault();

        let validationErrors = {};

        if (!title.trim()) {
            validationErrors.title = "Please enter the video title.";
        }

        if (!description.trim()) {
            validationErrors.description = "Please enter the description.";
        }

        if (!category) {
            validationErrors.category = "Please select a category.";
        }

        if (!video) {
            validationErrors.video = "Please select a video.";
        }

        if (Object.keys(validationErrors).length > 0) {

            setErrors(validationErrors);
            return;

        }

        setErrors({});
        setLoading(true);

        try {

            const formData = new FormData();

            formData.append("file", video);
            formData.append("upload_preset", UPLOAD_PRESET);

            const response = await fetch(VIDEO_UPLOAD_URL, {

                method: "POST",
                body: formData

            });

            const data = await response.json();

            if (!response.ok || !data.secure_url) {

                throw new Error("Video Upload Failed");

            }

            const selectedCategory = categories.find(
                (cat) => cat.id === category
            );

            await addDoc(
                collection(db, "videos"),
                {

                    title: title,

                    description: description,

                    category: selectedCategory.title,

                    videoUrl: data.secure_url,

                     createdAt: serverTimestamp()

                }
            );

 setPopup({
    show: true,
    type: "success",
    message: "Your video has been uploaded successfully and is now available in the gallery."
});

setTimeout(() => {

    setPopup({
        show: false,
        type: "",
        message: ""
    });

}, 3000);

            setTitle("");
            setDescription("");
            setCategory("");
            setVideo(null);

            document.getElementById("videoInput").value = "";

        } catch (error) {

            console.log(error);

            setPopup({
    show: true,
    type: "error",
    message: "Video Upload Failed. Please Try Again."
});

setTimeout(() => {

    setPopup({
        show: false,
        type: "",
        message: ""
    });

}, 3000);

        } finally {

            setLoading(false);

        }

    };

    return (

    <>
           {popup.show && (

    <div className={`luxury-popup ${popup.type}`}>

        <div className="popup-icon">

            {popup.type === "success"
                ? "✓"
                : "✕"}

        </div>

        <div className="popup-content">

            <h3>

                {popup.type === "success"
                    ? "Success"
                    : "Error"}

            </h3>

            <p>

                {popup.message}

            </p>

        </div>

    </div>

)}
        <AdminNavbar />

        <div className="dashboard-container">

            <Sidebar />

            <div className="upload-container">

                <div className="upload-header">

                    <h1>Upload New Video</h1>

                    <p>

                        Upload premium cinematic videos to your
                        Story Line Studios gallery.

                    </p>

                </div>

                <div className="upload-card">

                    {/*========================
                        VIDEO PREVIEW
                    ========================*/}

                    <div className="preview-panel">

                        {video ? (

                            <video
                                controls
                                className="preview-image"
                            >

                                <source
                                    src={URL.createObjectURL(video)}
                                    type={video.type}
                                />

                                Your browser does not support video.

                            </video>

                        ) : (

                            <div className="empty-preview">

                                <div className="camera-icon">

                                    🎥

                                </div>

                                <h2>

                                    Live Preview

                                </h2>

                                <p>

                                    Select a video to preview it
                                    before uploading.

                                </p>

                            </div>

                        )}

                    </div>

                    {/*========================
                            FORM
                    ========================*/}

                    <form
                        className="upload-form"
                        onSubmit={handleSubmit}
                    >

                        <label>

                            Video Title

                        </label>

                        <input
                            type="text"
                            placeholder="Enter Video Title"
                            value={title}
                            onChange={(e) => {

                                setTitle(e.target.value);

                                setErrors({

                                    ...errors,

                                    title: ""

                                });

                            }}
                        />

                        {errors.title && (

                            <p className="error-text">

                                {errors.title}

                            </p>

                        )}

                        <label>

                            Category

                        </label>

                        <select
                            value={category}
                            onChange={(e) => {

                                setCategory(e.target.value);

                                setErrors({

                                    ...errors,

                                    category: ""

                                });

                            }}
                        >

                            <option value="">

                                Select Category

                            </option>

                            {categories.map((cat) => (

                                <option
                                    key={cat.id}
                                    value={cat.id}
                                >

                                    {cat.title}

                                </option>

                            ))}

                        </select>

                        {errors.category && (

                            <p className="error-text">

                                {errors.category}

                            </p>

                        )}

                        <label>

                            Description

                        </label>

                        <textarea
                            rows="5"
                            placeholder="Enter Video Description"
                            value={description}
                            onChange={(e) => {

                                setDescription(e.target.value);

                                setErrors({

                                    ...errors,

                                    description: ""

                                });

                            }}
                        />

                        {errors.description && (

                            <p className="error-text">

                                {errors.description}

                            </p>

                        )}

                        <label>

                            Select Video

                        </label>

                        <input
                            id="videoInput"
                            type="file"
                            accept="video/*"
                            onChange={(e) => {

                                setVideo(e.target.files[0]);

                                setErrors({

                                    ...errors,

                                    video: ""

                                });

                            }}
                        />

                        {errors.video && (

                            <p className="error-text">

                                {errors.video}

                            </p>

                        )}

                        {loading && (

                            <div className="uploading-text">

                                🎥 Uploading Video...
                                Please wait...

                            </div>

                        )}

                        <button
                            type="submit"
                            disabled={loading}
                        >

                            {loading

                                ? "Uploading..."

                                : "Upload Video"}

                        </button>

                    </form>

                </div>

            </div>

        </div>

        <Footer />

    </>

);
}

export default UploadVideo;